'use client'

import { useEffect, useState } from 'react'

export function VideoViewsSkeleton() {
  return <div className="h-4 w-24 animate-pulse rounded-full bg-gray-100"></div>
}

export default function VideoViews({ youtubeId }: { youtubeId: string }) {
  const [views, setViews] = useState<string | null>(null)

  useEffect(() => {
    let isMounted = true

    async function fetchViews() {
      try {
        const response = await fetch(`/api/youtube/${youtubeId}`)
        if (!response.ok) return
        const data = await response.json()
        if (isMounted && data.views) {
          setViews(data.views)
        }
      } catch {
        // Fail silently — view count is non-critical
      }
    }

    fetchViews()

    return () => {
      isMounted = false
    }
  }, [youtubeId])

  if (!views) return null

  return <span className="relative z-10 text-12 text-gray-500">{views}</span>
}
